module.exports = __webpack_public_path__ + "static/media/logo.29a5db3c.png";